// ---------------------AssessmentReport-------------------------------------

export const ASSESSMENT_REPORT_SCREEN_TIME = [
  { id: 1, name: 'Less than 30 minutes' },
  { id: 2, name: '30 minutes - 1 hour' },
  { id: 3, name: '1 - 2 hours' },
  { id: 4, name: '2 - 3 hours' },
  { id: 5, name: '3 - 4 hours' },
  { id: 6, name: '4 - 5 hours' },
  { id: 7, name: 'More than 5 hours' },
];

export const ASSESSMENT_REPORT_HOBBIES = [
  { id: 1, name: 'Reading' },
  { id: 2, name: 'Sports' },
  { id: 3, name: 'Music' },
  { id: 4, name: 'Traveling' },
  { id: 5, name: 'Gaming' },
  { id: 6, name: 'Cooking' },
  { id: 7, name: 'Drawing / Art' },
  { id: 8, name: 'Dancing' },
  { id: 9, name: 'Photography' },
  { id: 10, name: 'Writing' },
  { id: 11, name: 'Coding / Programming' },
  { id: 12, name: 'Fitness / Gym' },
  { id: 13, name: 'Yoga' },
  { id: 14, name: 'Gardening' },
  { id: 15, name: 'Movies / Watching Shows' },
  { id: 16, name: 'Volunteering' },
  { id: 17, name: 'Other' },
];

export const ASSESSMENT_REPORT_AMBITION = [
  { id: 1, name: 'Software Engineer' },
  { id: 2, name: 'Doctor' },
  { id: 3, name: 'Engineer' },
  { id: 4, name: 'Scientist' },
  { id: 5, name: 'Teacher' },
  { id: 6, name: 'Entrepreneur' },
  { id: 7, name: 'Pilot' },
  { id: 8, name: 'Artist / Designer' },
  { id: 9, name: 'Musician' },
  { id: 10, name: 'Actor / Performer' },
  { id: 11, name: 'Lawyer' },
  { id: 12, name: 'Civil Servant (IAS/IPS)' },
  { id: 13, name: 'Nurse / Healthcare Professional' },
  { id: 14, name: 'Athlete / Sports Professional' },
  { id: 15, name: 'Business Professional' },
  { id: 16, name: 'Chef' },
  { id: 17, name: 'Writer / Journalist' },
  { id: 18, name: 'Digital Creator / Influencer' },
  { id: 19, name: 'Other' },
];

// --------------------course--------------------------------

export const SKILLX_DEPARTMENT_ID = 35;
// matches CourseAvailable.project_id for SkillX courses (backend cartUtils.skillxProjectId)
export const SKILLX_PROJECT_ID = 8;

// --------------------config---------------------------------

export const CONFIG_TYPES = [
  { id: 1, name: 'All Users' },
  // { id: 2, name: 'Specific User' },
  // { id: 3, name: 'Department' },
  // { id: 4, name: 'Role' },
  { id: 5, name: 'Working Mode' },
  { id: 6, name: 'Set Constant Value' },
];

export const CONFIG_WORKING_MODE = [
  { id: 1, name: 'On Site' },
  { id: 2, name: 'Remote' },
  { id: 3, name: 'Hybrid' },
];

export const ATTENDANCE_BUTTON_ID = 2;

//REFUND
// export const refundRequestReason = [
//   { id: 1, reason: 'Tutor' },
//   { id: 2, reason: 'Student' },
//   { id: 3, reason: 'OGA' },
//   { id: 4, reason: 'CRO' },
//   { id: 5, reason: 'Early Completion/ Portion Mismanagement' },
//   { id: 6, reason: 'Course Or Content' },
// ];

//NEVER CHANGE THE REASON NAME,ITS SERVING TO BACKEND AND ALREDY WRITTEN CONDITIONS
export const refundRequestReason = [
  { id: 1, reason: 'Tutor Related' },
  { id: 2, reason: 'Student Related' },
  { id: 3, reason: 'CRO Related' },
  { id: 4, reason: 'OGA Related' },
  { id: 5, reason: 'Early Completion / Portion Mismanagement' },
  { id: 6, reason: 'Course or Content Expectations Not Met / Not Offered' },
  { id: 7, reason: 'Non-Started Courses' },
  { id: 8, reason: 'TA Related' },
  { id: 9, reason: 'Cancellation of Specific Subject' },
  { id: 10, reason: 'SME Related' },
];

export const refundGlobalStatus = [
  { id: 0, label: 'All' },

  { id: 1, label: 'SOGO Approval Pending' },
  { id: 2, label: 'SOGO Approved' },
  { id: 3, label: 'SOGO Approval Rejected' },

  { id: 4, label: 'CRM Approval Pending' },
  { id: 5, label: 'CRM Approved' },
  { id: 6, label: 'CRM Approval Rejected' },

  { id: 7, label: 'SOGO Verification Pending' },
  { id: 8, label: 'SOGO Verified' },
  { id: 9, label: 'SOGO Verification Rejected' },

  { id: 10, label: 'CRM Verification Pending' },
  { id: 11, label: 'CRM Verified' },
  { id: 12, label: 'CRM Verification Rejected' },

  { id: 13, label: 'PM Approval Pending' },
  { id: 14, label: 'PM Approved' },
  { id: 15, label: 'PM Approval Rejected' },

  { id: 16, label: 'Finance Approval Pending' },
  { id: 17, label: 'Finance Approved' },
  { id: 18, label: 'Finance Hold' },
  { id: 19, label: 'Finance Rejected' },
];

// --------------------------cart inr for aed-----------------------

export const CART_AED_TO_INR_VALUE = 25;

export const typeOfStudent = [
  { id: 0, name: 'Tution Fee' },
  { id: 1, name: 'Hold Amount' },
];

export const foodAvailability = [
  { id: -1, name: 'All Users' },
  { id: 0, name: 'Non Blocked Users' },
  { id: 1, name: 'Blocked Users' },
];

export const refundStatusBy = [
  { id: 1, name: 'CRM' },
  { id: 2, name: 'Sogo' },
  { id: 3, name: 'PM' },
  { id: 4, name: 'Finance' },
];

export const refundStatusType = [
  { id: 0, name: 'Pending' },
  { id: 1, name: 'Approved' },
  { id: 2, name: 'Rejected' },
];

export const ogdWings = [
  {
    id: 62,
    value: 'Ventas Squad',
  },
  {
    id: 63,
    value: 'Goal Setters',
  },
  {
    id: 64,
    value: 'Deal Maestros',
  },
  {
    id: 65,
    value: 'Chaser Crew',
  },
  {
    id: 66,
    value: 'ECPC',
  },
  {
    id: 67,
    value: 'Manager',
  },
  {
    id: 110,
    value: 'Quality Wing',
  },
  {
    id: 115,
    value: 'Edex',
  },
];
